'use client'

import {useSearchParams} from 'next/navigation'
import {grid, gridItem} from '~/design-system/foundations'
import {HgArticleListing} from '~/design-system/hg/components'
import HgPaginationBlock from '~/design-system/hg/modules/HgPaginationBlock'
import {type HgArticleListingIndexStackedProps} from './types'

const PAGINATION_ITEM_THRESHOLD = 24
const ITEMS_PER_PAGE = 24

const HgArticleListingIndexStacked = ({
  articles,
}: HgArticleListingIndexStackedProps) => {
  const searchParams = useSearchParams()
  const pageParam = searchParams.get('page')
  const page =
    pageParam && !isNaN(Number(pageParam)) ? Math.max(1, Number(pageParam)) : 1

  const articlesToDisplay = articles.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  )
  const shouldShowPagination = articles.length > PAGINATION_ITEM_THRESHOLD

  return (
    <>
      <div
        className={grid({
          className: 'mx-auto scroll-m-blog-navbars-height px-s5 pt-s8',
        })}
        id="listing-top"
      >
        <div
          className={gridItem({
            className: 'grid grid-cols-1 gap-x-s4 gap-y-s8 md:grid-cols-4',
          })}
        >
          {articlesToDisplay.map((article, idx) => (
            <HgArticleListing
              key={`${article.slug}-${idx}`}
              variant="stacked"
              aspectRatio="16:9"
              textAlignment="left"
              size="heading-7"
              showSubheading={false}
              {...article}
            />
          ))}
        </div>
      </div>
      {shouldShowPagination && (
        <div className="col-span-full">
          <HgPaginationBlock
            data={articles}
            controlProps={{itemsPerPage: ITEMS_PER_PAGE}}
            scrollToId="listing-top"
          />
        </div>
      )}
    </>
  )
}

export default HgArticleListingIndexStacked
